import React from 'react';
import '../App.css';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { Dropdown, Button } from 'react-bootstrap';
import Exit from '../exit.png';
import logo from '../CCLogo_Black.jpg';

export default class MobileHeader extends React.Component {
    render() {
        const title = this.props.jurorName ? `Welcome, ${this.props.jurorName}` : 'Welcome';

        return (
            <header className="mobile-header">
                <Link to="/">
                    <img className="Header-logo" alt="County Logo" src={logo} />
                </Link>

                <h1>Juror Portal</h1>

                <div className="Header-welcome">
                    <Dropdown>
                        <Button variant="header_btn">{title}</Button>
                        {this.props.logOut
                            ? [
                                  <Dropdown.Toggle split variant="header_btn" id="dropdown-custom-2">
                                      <img className="Check" alt="Sign Out" src={Exit} />
                                  </Dropdown.Toggle>,
                                  <Dropdown.Menu variant="header_btn">
                                      <Dropdown.Item as="button" onClick={this.props.logOut} variant="header_btn">
                                          Sign Off
                                      </Dropdown.Item>
                                  </Dropdown.Menu>
                              ]
                            : ''}
                    </Dropdown>

                    <span className="Header-welcome-label">
                        {this.props.jurorReportingDateTime
                            ? [
                                  'Jury Reporting Date: ',
                                  <br />,
                                  `${moment(this.props.jurorReportingDateTime).format('L')} ${moment(this.props.jurorReportingDateTime).format(
                                      'h:mm a'
                                  )}`
                              ]
                            : ''}
                    </span>
                </div>
            </header>
        );
    }
}
